import appSettings from 'apps/services/config'
import React from 'react'

const warehousedashboard = () => {
    return(
        <>
       <iframe
        src={appSettings.dashboard_url+'/warehouseDashboard'}
        title="Example Iframe"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        
        ></iframe>
       </>
    )
}

export default warehousedashboard